"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const es_db_mapper_1 = __importDefault(require("../base/es-db-mapper"));
const ctr_model_1 = __importDefault(require("./ctr.model"));
class CTRMapper extends es_db_mapper_1.default {
    constructor() {
        super(...arguments);
        this.hasSubIndex = true;
    }
    getIndex(model) {
        return this.name + `-${new Date(model.InitiationTimestamp).toISOString().slice(0, 10)}`;
    }
    hierarchyStructure2(ctr) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return [
            (_c = (_b = (_a = ctr.Agent) === null || _a === void 0 ? void 0 : _a.HierarchyGroups) === null || _b === void 0 ? void 0 : _b.Level1) === null || _c === void 0 ? void 0 : _c.ARN,
            (_f = (_e = (_d = ctr.Agent) === null || _d === void 0 ? void 0 : _d.HierarchyGroups) === null || _e === void 0 ? void 0 : _e.Level2) === null || _f === void 0 ? void 0 : _f.ARN,
            (_j = (_h = (_g = ctr.Agent) === null || _g === void 0 ? void 0 : _g.HierarchyGroups) === null || _h === void 0 ? void 0 : _h.Level3) === null || _j === void 0 ? void 0 : _j.ARN,
            (_m = (_l = (_k = ctr.Agent) === null || _k === void 0 ? void 0 : _k.HierarchyGroups) === null || _l === void 0 ? void 0 : _l.Level4) === null || _m === void 0 ? void 0 : _m.ARN,
            (_q = (_p = (_o = ctr.Agent) === null || _o === void 0 ? void 0 : _o.HierarchyGroups) === null || _p === void 0 ? void 0 : _p.Level5) === null || _q === void 0 ? void 0 : _q.ARN,
        ]
            // Filter out falsey values
            .filter(Boolean)
            .map(this.idFromArn)
            .join('/');
    }
    idFromArn(arn) {
        return arn ? arn.slice(arn.lastIndexOf('/') + 1) : undefined;
    }
    parseAthenaTimestamp(timestamp) {
        return new Date(timestamp).getTime();
    }
    transform(companyID, ctr) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return {
            ID: ctr.ContactId,
            channel: ctr.Channel,
            agentID: this.idFromArn((_a = ctr.Agent) === null || _a === void 0 ? void 0 : _a.ARN),
            // agentName: ctr.agent_name,
            queueID: this.idFromArn((_b = ctr.Queue) === null || _b === void 0 ? void 0 : _b.ARN),
            // username: ctr.agent_username,
            inQueueDuration: parseInt(((_c = ctr.Queue) === null || _c === void 0 ? void 0 : _c.Duration.toString()) || '') || 0,
            queueName: (_d = ctr.Queue) === null || _d === void 0 ? void 0 : _d.Name,
            answered: ctr.Agent ? true : false,
            agentInteractionDuration: parseInt(((_e = ctr.Agent) === null || _e === void 0 ? void 0 : _e.AgentInteractionDuration.toString()) || '') || 0,
            afterContactWorkDuration: parseInt(((_f = ctr.Agent) === null || _f === void 0 ? void 0 : _f.AfterContactWorkDuration.toString()) || '') || 0,
            description: (_g = ctr.ContactDetails) === null || _g === void 0 ? void 0 : _g.Description,
            numberOfHolds: parseInt(((_h = ctr.Agent) === null || _h === void 0 ? void 0 : _h.NumberOfHolds.toString()) || '') || 0,
            holdDuration: parseInt(((_j = ctr.Agent) === null || _j === void 0 ? void 0 : _j.CustomerHoldDuration.toString()) || '') || 0,
            topHierarchyGroupID: this.idFromArn((_m = (_l = (_k = ctr.Agent) === null || _k === void 0 ? void 0 : _k.HierarchyGroups) === null || _l === void 0 ? void 0 : _l.Level1) === null || _m === void 0 ? void 0 : _m.ARN),
            hierarchyStructure: this.hierarchyStructure2(ctr),
            initiationMethod: ctr.InitiationMethod,
            instanceID: this.idFromArn(ctr.InstanceARN),
            companyID: companyID,
            routingProfileID: this.idFromArn((_p = (_o = ctr.Agent) === null || _o === void 0 ? void 0 : _o.RoutingProfile) === null || _p === void 0 ? void 0 : _p.ARN),
            initiationTimestamp: this.parseAthenaTimestamp(ctr.InitiationTimestamp),
            connectedToAgentTimestamp: ((_q = ctr.Agent) === null || _q === void 0 ? void 0 : _q.ConnectedToAgentTimestamp) &&
                this.parseAthenaTimestamp((_r = ctr.Agent) === null || _r === void 0 ? void 0 : _r.ConnectedToAgentTimestamp) || undefined,
            connectedToSystemTimestamp: ctr.ConnectedToSystemTimestamp &&
                this.parseAthenaTimestamp(ctr.ConnectedToSystemTimestamp) || undefined,
            disconnectTimestamp: this.parseAthenaTimestamp(ctr.DisconnectTimestamp),
            longestHoldDuration: parseInt(((_s = ctr.Agent) === null || _s === void 0 ? void 0 : _s.LongestHoldDuration.toString()) || '') || 0,
            agentConnectionAttempts: ctr.AgentConnectionAttempts || 0,
            systemEndpointAddress: (_t = ctr.SystemEndpoint) === null || _t === void 0 ? void 0 : _t.Address,
            attributes: ctr.Attributes,
            customerEndpointAddress: ctr.CustomerEndpoint.Address,
            // Are required because of type but not used
            created: 0,
            updated: 0,
        };
    }
    render(rawCTR) {
        // Transform ctr
        return this.transform(rawCTR.companyID, super.render(rawCTR));
    }
}
exports.default = (config) => es_db_mapper_1.default.registerModel('contact-trace-records', ctr_model_1.default, CTRMapper, config)();
